import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { OfferModel } from '../applicant-file-service/models/offer-model';
import { ApplicantFileService } from '../applicant-file-service/applicant-file.service';

@Injectable()
export class OfferResolver implements Resolve<OfferModel> {

  constructor(private service: ApplicantFileService) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<OfferModel> {
    return this.service.getOffer(
      route.parent.params['jobId'],
      route.parent.params['applicantFileId'],
      route.params['offerId']);
  }
}
